export default __webpack_public_path__ + "static/step-3-bfa35bcb10ad4b08ee6470ff7a27e44c.png";